export function rewardPointsWorth(points, pointsPerUnitCurrency) {
  return points > 0 && pointsPerUnitCurrency > 0
    ? Math.ceil(points / pointsPerUnitCurrency)
    : 0;
}
